import * as Models from "../.";
export interface ISaveSystemReviewRequest {
  systemReview: Models.Customer.SystemReview.SystemReview;
  igsCustomerNumber: string;
}

export class SaveSystemReviewRequest implements ISaveSystemReviewRequest {
  systemReview: Models.Customer.SystemReview.SystemReview;
  igsCustomerNumber: string;
}
